module.exports = __webpack_public_path__ + "img/chargingpoint-disabled.c4be6410.png";